export const getDomainWithPath = (): string => {
  const [_, urlWithoutProtocol] = window.location.href.split('//');
  const [domainWithPath = ''] = urlWithoutProtocol.split('?');

  return domainWithPath;
};
